import React, { useState } from 'react';
import { List, useTable, EditButton, ShowButton, DeleteButton } from '@refinedev/antd';
import { useCustom } from '@refinedev/core';
import { Table, Space, Tag, Input, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { MealDto } from '@wellverse/shared-ts';
import { ExcelButtons } from '../../components/ExcelButtons';

export const MealList: React.FC = () => {
  const [searchText, setSearchText] = useState('');
  const [selectedRestaurantId, setSelectedRestaurantId] = useState<string | undefined>(undefined);

  const { data: restaurantsData } = useCustom({
    url: '/restaurant',
    method: 'get',
    config: { query: { limit: 100 } },
  });
  const restaurants = restaurantsData?.data?.items || [];

  const { tableProps } = useTable<MealDto>({
    resource: 'meals',
    filters: {
      permanent: [
        { field: 'search', operator: 'contains' as const, value: searchText },
        ...(selectedRestaurantId
          ? [{ field: 'restaurantId', operator: 'eq' as const, value: selectedRestaurantId }]
          : []),
      ],
    },
    pagination: { current: 1, pageSize: 20 },
    queryOptions: { keepPreviousData: true },
  });

  return (
    <List resource="meals">
      <div style={{ marginBottom: 16, display: 'flex', gap: 12, alignItems: 'center' }}>
        <Input.Search
          prefix={<SearchOutlined />}
          placeholder="Search meals by name..."
          defaultValue={searchText}
          onSearch={(value) => setSearchText(value)}
          allowClear
          style={{ width: 320 }}
        />
        <Select
          placeholder="Filter by restaurant"
          allowClear
          style={{ width: 280 }}
          value={selectedRestaurantId}
          onChange={(value) => setSelectedRestaurantId(value)}
        >
          {restaurants.map((r: any) => (
            <Select.Option key={r.id} value={r.id}>
              {r.name}
            </Select.Option>
          ))}
        </Select>
        <ExcelButtons resource="restaurant-admin/meals" filename="meals" />
      </div>
      <Table {...tableProps} rowKey="id" scroll={{ x: 1000 }}>
        <Table.Column dataIndex="name" title="Name" fixed="left" width={180} />
        <Table.Column
          dataIndex="restaurantName"
          title="Restaurant"
          width={160}
          render={(v: string) => v || '—'}
        />
        <Table.Column
          dataIndex="menuCategoryName"
          title="Category"
          width={140}
          render={(v: string) => v || '—'}
        />
        <Table.Column dataIndex="caloriesPerServing" title="Calories" width={100} />
        <Table.Column
          dataIndex="proteinPerServing"
          title="Protein (g)"
          width={110}
          render={(v: number) => v != null ? v : '—'}
        />
        <Table.Column
          dataIndex="isActive"
          title="Active"
          width={90}
          render={(isActive: boolean) => (
            <Tag
              style={{
                borderColor: isActive ? '#3ecf8e' : '#898989',
                color: isActive ? '#3ecf8e' : '#898989',
                background: isActive ? '#3ecf8e15' : '#89898915',
                borderRadius: 9999,
                padding: '2px 12px',
                fontWeight: 500,
              }}
            >
              {isActive ? 'Active' : 'Inactive'}
            </Tag>
          )}
        />
        <Table.Column
          title="Actions"
          dataIndex="actions"
          fixed="right"
          width={120}
          render={(_: any, record: MealDto) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} resource="meals" />
              <ShowButton hideText size="small" recordItemId={record.id} resource="meals" />
              <DeleteButton hideText size="small" recordItemId={record.id} resource="meals" />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
